// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"8":"form-work","79":"news-view","322":"bottom","500":"product-view","521":"video-view","667":"regard","752":"relation-view"}[chunkId] + "." + {"8":"9a7092a9","79":"f5916f63","322":"30f095a9","500":"b50c2dcc","521":"dacbf4e3","667":"269fe6f8","752":"6198c996"}[chunkId] + ".js";
};